export default __webpack_public_path__ + "static/media/pp1.dde682b8.png";